/* eslint-disable no-console */
import { log, supabase } from ".";

// Nota: sales_btl NO tiene columna `ano` — el filtrado por año lo hacen los callers
// en JS (sobre mes_cierre / mes_factura / facturafecha). Por eso acá solo se filtra
// por `pais` server-side. Los callers pueden seguir pasando `ano`, pero se ignora.
export const getOportunidadesBTL = async ({ pais, orderBy = "created_at", ascending = true }) => {
  try {
    const filters = {};
    if (pais) filters.pais = pais;

    const data = await supabase.select("sales_btl", {
      filters,
      orderBy,
      ascending,
    });

    return data || [];
  } catch (error) {
    log.error("getOportunidadesBTL", error);
    throw error;
  }
};
